// extracted by mini-css-extract-plugin
export default {"gradientAnimation":"arChRt","gradient":"brChRt","invertedColors":"crChRt"};